import { Unit } from "../UnitView/unitTypes";
import { listOptionsForAuthorisedUnits } from "../OrdererView/OrdererView.utils";
import { Administrator, AdministratorListingItem } from "./administratorTypes";

export const administratorRoleLabel = (
    role: Administrator["municipalityRole"] | "ORDERER",
) => {
    if (role === "ORDERER_ADMIN") {
        return "Beställare administratör";
    }

    if (role === "ORDERER") {
        return "Beställare";
    }

    return "Administratör";
};

export const mapAdministratorsForListing = (
    administrators: Administrator[],
    allUnits: Unit[],
): AdministratorListingItem[] =>
    administrators.map((administrator) => ({
        administrator,
        authUnits:
            administrator.municipalityRole === "ORDERER_ADMIN"
                ? listOptionsForAuthorisedUnits(administrator.authorisedUnitCodes, allUnits)
                : [],
    }));
